import { axiosInstance } from '~/api/config/axios.config';
import { AuthResponse } from '~/features/auth/store/models';
import { conformObjectResponse } from '~/api/utils';

export class AuthApi {
    static async login(data: { email: string; password: string }) {
        return conformObjectResponse(axiosInstance.post('/login', { ...data }), AuthResponse);
    }
}
